import {
  Box,
  Card,
  CardContent,
  FormControlLabel,
  Switch
} from '@mui/material';
import {
  getEventUserPreferences,
  updateEventUserPreferences
} from 'api/services/UserService';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ProfileTitleSection } from '../user/UserProfile/UserProfile';

interface Props {
  brandPortalEvent: { key: string; name: string };
}

const CustomNotifications: React.FC<Props> = ({ brandPortalEvent }) => {
  const onLabelUpdateHandler = (
    type: 'product' | 'company',
    currentValue: boolean
  ) => {
    updateEventUserPreferences(
      brandPortalEvent.key,
      {
        notifications:
          type === 'company'
            ? {
                PRODUCT_LABEL_CHANGED: {
                  enabled: currentState.product,
                  frequency: { PUSH: 'LIVE' }
                },
                COMPANY_LABEL_CHANGED: {
                  enabled: !currentValue,
                  frequency: { PUSH: 'LIVE' }
                }
              }
            : {
                PRODUCT_LABEL_CHANGED: {
                  enabled: !currentValue,
                  frequency: { PUSH: 'LIVE' }
                },
                COMPANY_LABEL_CHANGED: {
                  enabled: currentState.company,
                  frequency: { PUSH: 'LIVE' }
                }
              }
      },
      () => {
        switch (type) {
          case 'company':
            setCurrentState(prev => ({ ...prev, company: !prev.company }));
            break;
          case 'product':
            setCurrentState(prev => ({ ...prev, product: !prev.product }));
            break;
        }
        setWasSwitchClicked(true);
        toast.success('Successfully updated Notifications Settings');
      },
      () => {
        toast.error(
          'Something went wrong while updating Notifications Settings'
        );
      }
    );
  };
  const [wasSwitchClicked, setWasSwitchClicked] = useState(false);
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [currentState, setCurrentState] = useState({
    product: true,
    company: true
  });
  useEffect(() => {
    if (isFirstRender || wasSwitchClicked)
      getEventUserPreferences(brandPortalEvent.key, (res: any) => {
        //TODO: Change to return the current values for the label and company update when backends ready
        const currentState = {
          product:
            res?.data?.notifications?.PRODUCT_LABEL_CHANGED !== undefined
              ? res.data.notifications.PRODUCT_LABEL_CHANGED.enabled
              : true,
          company:
            res?.data?.notifications?.COMPANY_LABEL_CHANGED !== undefined
              ? res.data.notifications.COMPANY_LABEL_CHANGED.enabled
              : true
        };
        setCurrentState({
          ...currentState
        });
        setWasSwitchClicked(false);
        if (isFirstRender) setIsFirstRender(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wasSwitchClicked]);
  return (
    <Card>
      <CardContent>
        <ProfileTitleSection
          title={`${brandPortalEvent.name}`}
          optionalTitle="Frequency"
        />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
          <div>
            <FormControlLabel
              control={
                <Switch
                  name={`Company label updates`}
                  id={`company-label`}
                  defaultChecked={currentState.company}
                  checked={currentState.company}
                  onChange={_ => {
                    onLabelUpdateHandler('company', currentState.company);
                  }}
                />
              }
              label={'Company label updates'}
            />
          </div>
          <>Live</>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
          <Box display={'flex'} alignItems={'center'}>
            <FormControlLabel
              control={
                <Switch
                  name={`Product label updates`}
                  id={`product-label`}
                  defaultChecked={currentState.product}
                  checked={currentState.product}
                  onChange={_ => {
                    onLabelUpdateHandler('product', currentState.product);
                  }}
                />
              }
              label={'Product label updates'}
            />
          </Box>
          <>Live</>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CustomNotifications;
